var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("EditorMenuBubble", {
    staticClass: "menububble",
    attrs: { editor: _vm.editor },
    on: { hide: _vm.hideLinkMenu },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var commands = ref.commands
          var isActive = ref.isActive
          var getMarkAttrs = ref.getMarkAttrs
          var menu = ref.menu
          return [
            _c(
              "div",
              {
                staticClass: "menububble",
                class: { "is-active": menu.isActive },
                style:
                  "left: " + menu.left + "px; bottom: " + menu.bottom + "px;"
              },
              [
                _vm.linkMenuIsActive
                  ? _c(
                      "form",
                      {
                        staticClass: "menububble__form",
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.setLinkUrl(commands.link, _vm.linkUrl)
                          }
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.linkUrl,
                              expression: "linkUrl"
                            }
                          ],
                          ref: "linkInput",
                          staticClass: "menububble__input",
                          attrs: { type: "text", placeholder: "https://" },
                          domProps: { value: _vm.linkUrl },
                          on: {
                            keydown: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k($event.keyCode, "esc", 27, $event.key, [
                                  "Esc",
                                  "Escape"
                                ])
                              ) {
                                return null
                              }
                              return _vm.hideLinkMenu($event)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.linkUrl = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("button", {
                          staticClass: "menububble__button icon-confirm",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.setLinkUrl(commands.link, _vm.linkUrl)
                            }
                          }
                        })
                      ]
                    )
                  : [
                      _c(
                        "button",
                        {
                          staticClass: "menububble__button",
                          class: { "is-active": isActive.link() },
                          on: {
                            click: function($event) {
                              _vm.showLinkMenu(getMarkAttrs("link"))
                            }
                          }
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: isActive.link()
                                  ? "Update Link"
                                  : "Add Link",
                                expression:
                                  "isActive.link() ? 'Update Link' : 'Add Link'"
                              }
                            ],
                            staticClass: "icon-link"
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "menububble__buttontext" },
                            [_vm._v(_vm._s(_vm.t("text", "Add link")))]
                          )
                        ]
                      )
                    ]
              ],
              2
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }